import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  defaultServerUrl,
  getServerUrl,
  hasServerUrl,
  normalizeServerUrl,
  setServerUrl,
} from '../constants/config'
import { api } from '../api/client'
import { useAuth } from '../hooks/useAuth'

// Server URL entry — the first screen before TOTP. The field is prefilled with a
// suggestion (the current origin on web, or the build-time default on native);
// if there's none the user types it. On connect we save it, verify the backend
// is reachable, then continue to the TOTP register/login screen.
export function ConnectPage() {
  const [url, setUrl] = useState(() => (hasServerUrl() ? getServerUrl() : defaultServerUrl()))
  const [error, setError] = useState('')
  const [checking, setChecking] = useState(false)
  const { logout } = useAuth()
  const navigate = useNavigate()

  const connect = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    const norm = normalizeServerUrl(url)
    if (!norm) {
      setError('รูปแบบ URL ไม่ถูกต้อง เช่น https://example.com:9119')
      return
    }

    // Switching to a different server invalidates the old session token.
    if (norm !== getServerUrl()) logout()
    setServerUrl(norm)
    setUrl(norm)

    setChecking(true)
    try {
      await api.auth.status() // uses the URL we just saved
      navigate('/login')
    } catch {
      setError('เชื่อมต่อเซิร์ฟเวอร์ไม่ได้ ตรวจ URL หรือใบรับรอง (cert) แล้วลองใหม่')
    } finally {
      setChecking(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <img src="/whimer-wordmark.svg" alt="Whimer" className="login-logo-wordmark" />
        </div>

        <h1>Connect</h1>
        <p className="login-hint">ที่อยู่เซิร์ฟเวอร์ของคุณ (โดเมนหรือ IP พร้อมพอร์ต)</p>

        <form onSubmit={connect} className="login-form">
          <input
            type="text"
            inputMode="url"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            value={url}
            onChange={e => setUrl(e.target.value)}
            placeholder="https://example.com:9119"
            autoFocus
            className="connect-input"
          />
          {error && <p className="login-error">{error}</p>}
          <button type="submit" disabled={checking || !url.trim()} className="login-btn">
            {checking ? 'กำลังเชื่อมต่อ...' : 'เชื่อมต่อ'}
          </button>
        </form>

        {error && (
          <button
            type="button"
            className="login-alt-link"
            onClick={() => navigate('/login')}
          >
            ไปต่อโดยไม่ตรวจสอบ
          </button>
        )}
      </div>
    </div>
  )
}
